import { ERS_METRIK_PARAM_PREFIX } from '../config.js';
import readCookie from './readCookie.js';

const ERS_METRIK_COOKIE_NAME = 'ers-metrik';
const ENTRY_SEPARATOR = '|';
const KEY_VALUE_SEPARATOR = '=';

/**
 * Zwischengespeicherter Cookie-Wert. Das Cookie bleibt über die Session stabil,
 * deshalb genügt ein einziger Read beim Laden des Moduls.
 */
const cachedCookieValue = readErsMetrikCookie();

/**
 * Liest das "ers-metrik"-Cookie (eReader-Kontext) und liefert dessen Einträge
 * als GA4-Event-Parameter.
 *
 * Cookie-Format: `device=TOLINO_SHINE_5C|model=SHINE|firmware=LINUX|audio=1`
 * Ergebnis: `{ ers_device: "TOLINO_SHINE_5C", ers_model: "SHINE", ers_firmware: "LINUX", ers_audio: "1" }`
 *
 * @returns {Object} Parameter-Objekt, leer wenn kein (oder ein leeres) Cookie gesetzt ist
 */
export function getErsMetrikParams() {
    if (!cachedCookieValue) {
        return {};
    }

    const params = {};
    for (const entry of cachedCookieValue.split(ENTRY_SEPARATOR)) {
        const separatorIndex = entry.indexOf(KEY_VALUE_SEPARATOR);
        if (separatorIndex < 1) {
            continue;
        }

        const key = entry.slice(0, separatorIndex).trim();
        const value = entry.slice(separatorIndex + 1).trim();
        if (!key || !value) {
            continue;
        }

        params[buildParamName(key)] = value;
    }

    return params;
}

/**
 * Liest das "ers-metrik"-Cookie.
 * @returns {string} Cookie-Wert oder leerer String, wenn es ihn nicht gibt
 */
function readErsMetrikCookie() {
    try {
        return readCookie(ERS_METRIK_COOKIE_NAME) || '';
    } catch (error) {
        console.warn('[DataLayer] Failed to read ers-metrik cookie', error);
        return '';
    }
}

/**
 * Baut aus einem Cookie-Key einen GA4-konformen Parameter-Namen (`device` → `ers_device`).
 * GA4 erlaubt in Parameter-Namen nur Buchstaben, Zahlen und Unterstriche.
 * @param {string} key - Key aus dem Cookie
 * @returns {string} Parameter-Name mit ers-Prefix
 */
function buildParamName(key) {
    const normalizedKey = key.toLowerCase().replace(/[^a-z0-9_]/g, '_');
    return `${ERS_METRIK_PARAM_PREFIX}${normalizedKey}`;
}
